module.exports = __webpack_public_path__ + "media/6.9daf239f.wav";